import { mapActions, mapGetters } from 'vuex';
import ArwIcon from '@/components/ArwIcon/index.vue';

export default {
  name: 'GallerySlider',
  props: {
    images: {
      type: Array,
      required: true,
    },
    visibleItems: {
      type: Number,
      default: 5,
      required: false,
    },
  },
  data() {
    return {
      currentSlideGroup: 0,
      currentTranslate: 0,
      height: 0,
      thumbnailEl: null,

    };
  },
  computed: {
    ...mapGetters([
      'getActiveImageIndex',
      'getViewerOpen',
    ]),
    showDisplaySlider() {
      return this.images.length > 1 && !this.getViewerOpen;
    },
    showUpControl() {
      return this.currentSlideGroup > 0;
    },
    showDownControl() {
      return this.images.length / this.visibleItems > this.currentSlideGroup + 1;
    },
    calculateHeight() {
      return `height: ${this.height}px;`;
    },
    calculateTransform() {
      return `transform: translateY(-${this.currentTranslate}px)`;
    },
    activeImage() {
      return this.getActiveImageIndex;
    },
    thumbnailHeight() {
      if (!this.thumbnailEl || !this.thumbnailEl.length) return 0;
      const el = this.thumbnailEl[0];
      const style = getComputedStyle(el);
      return el.offsetHeight + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    },
  },
  watch: {
    activeImage(newIndex) {
      const slideGroup = Math.floor(newIndex / this.visibleItems);

      if (this.currentSlideGroup !== slideGroup) {
        this.currentSlideGroup = slideGroup;
        this.updateTranslate();
      }
    },
  },
  mounted() {
    this.updateSliderHeight();
  },
  updated() {
    this.updateSliderHeight();
  },
  methods: {
    setThumbnailGaAttr(href) {
      return `EMS - Gallery Thumbnail, click, ${href}`;
    },
    setArrowGaAttr(direction) {
      return `EMS - Gallery Arrow, click, ${direction}`;
    },
    ...mapActions([
      'updateActiveImageIndex',
    ]),
    updateSliderHeight() {
      this.$nextTick(() => {
        this.thumbnailEl = this.$refs.thumbnail;
        this.height = this.visibleItems * this.thumbnailHeight;
      });
    },
    isThumbnailActiveClass(index) {
      return {
        'app__gallery__slider__thumbnail--active': index === this.getActiveImageIndex,
      };
    },
    isControlHidden(flag) {
      return {
        'app__gallery__slider__thumbnail__control--hidden': !flag,
      };
    },
    selectImage(index) {
      this.updateActiveImageIndex(index);
    },
    isTabbable(index) {
      const slideGroup = Math.floor(index / this.visibleItems);
      return this.currentSlideGroup === slideGroup ? '0' : '-1';
    },
    updateTranslate() {
      this.currentTranslate = this.currentSlideGroup * (this.thumbnailHeight * this.visibleItems);
    },
    slide(direction) {
      if (direction === 'up') {
        this.currentSlideGroup -= 1;
      } else {
        this.currentSlideGroup += 1;
      }
      this.updateTranslate();
    },
  },
  components: {
    ArwIcon,
  },
};
